'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { Spinner } from '../spinner/spinner';
import { AssistChipContext } from './context/assist-chip.context';
import { assistChipLoadingStyles } from './styles/assist-chip-loading.styles';
import type { AssistChipLoadingPropsInterface } from './types/assist-chip-loading.types';

/**
 * @since 10.0.0
 */
export const AssistChipLoading = forwardRef<HTMLSpanElement, AssistChipLoadingPropsInterface>(
  (props, forwardedRef) => {
    const { loadingVoiceOver } = useContext(AssistChipContext);
    const { css: cssProp, className, ...rest } = props;
    const styles = css({ ...assistChipLoadingStyles, ...cssProp });
    return (
      <span
        ref={forwardedRef}
        data-c11n-component="AssistChip.Loading"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'group', styles, className)}
        {...rest}
      >
        <Spinner title={loadingVoiceOver} />
      </span>
    );
  },
);

AssistChipLoading.displayName = 'AssistChip.Icon';
